module.exports = __webpack_public_path__ + "media/images/autopilot/datesearch-60508549154e1710dda9ec8e3ee9f9d9.svg";